// ---------------------------------------------------------------------------
// Entry point. Islands, not a single-page app.
//
// The six subpages of a dashboard are six ordinary Django URLs. Each one drops
// empty mount points into its template and this bundle fills them in, the same
// way sanctions/app/src/main.js does. Nothing here takes over routing.
// ---------------------------------------------------------------------------

import { createApp } from 'vue'
import './scss/main.scss'

import { flight } from './flight.js'
import { countdown } from './countdown.js'
import { chapterSpy, condenseHeader } from './spy.js'
import { keepFilterOnLinks } from './store.js'

import CasePath from './components/CasePath.vue'
import CaseTable from './components/CaseTable.vue'
import CaseTimers from './components/CaseTimers.vue'
import DurationHistogram from './components/DurationHistogram.vue'
import MarketPie from './components/MarketPie.vue'
import FilterBar from './components/FilterBar.vue'
import RankedBars from './components/RankedBars.vue'
import SectorDonut from './components/SectorDonut.vue'
import SizeBands from './components/SizeBands.vue'
import TopContracts from './components/TopContracts.vue'

/**
 * Mount a component onto a placeholder, if the current page has one.
 *
 * One bundle serves every subpage, so most mount points are absent on any
 * given page — hence the guard. Props come from the element's data-*
 * attributes, which is how the Django template hands over what it knows
 * (see sanctions/app/src/adminsite.js). They arrive as strings; a component
 * that wants a number declares it in defineProps and Vue casts it.
 */
export function mount(selector, component) {
    const el = document.querySelector(selector)
    if (el) createApp(component, { ...el.dataset }).mount(el)
}

// Every call is a no-op on the pages that do not carry the mount point, so one
// bundle can list all of them.
mount('#uohs-filtr', FilterBar)
mount('#uohs-casomiry', CaseTimers)
mount('#uohs-delky', DurationHistogram)
mount('#uohs-cesta', CasePath)
mount('#uohs-podil', MarketPie)
mount('#uohs-nejdrazsi', TopContracts)
mount('#uohs-trh-obory', SectorDonut)
mount('#uohs-zadavatele', RankedBars)
mount('#uohs-velikosti', SizeBands)
mount('#uohs-tabulka', CaseTable)

// Server-rendered links are in the document by now: main.js is a module, so it
// runs after parsing.
keepFilterOnLinks()
flight()
chapterSpy()
condenseHeader()
countdown()
